export function formatMoney(value: number, locale = 'es-US'): string {
  return new Intl.NumberFormat(locale, {
    currency: 'USD',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'currency',
  }).format(value);
}

export function formatShortDate(date: string, locale = 'es-US'): string {
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  }).format(toUTCDate(date));
}

export function formatLongDate(date: string, locale = 'es-US'): string {
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'long',
    timeZone: 'UTC',
    year: 'numeric',
  }).format(toUTCDate(date));
}

export function formatMonth(year: number, month: number, locale = 'es-US'): string {
  return new Intl.DateTimeFormat(locale, {
    month: 'long',
    timeZone: 'UTC',
    year: 'numeric',
  }).format(new Date(Date.UTC(year, month - 1, 1)));
}

export function formatMonthShort(year: number, month: number, locale = 'es-US'): string {
  return new Intl.DateTimeFormat(locale, {
    month: 'short',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(year, month - 1, 1)));
}

function toUTCDate(date: string): Date {
  return new Date(`${date.slice(0, 10)}T00:00:00.000Z`);
}
